/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FileServiceGetFileDetailsResponse,
  FileServiceGetFileLinkResponse,
} from '../models/index';
import {
    FileServiceGetFileDetailsResponseFromJSON,
    FileServiceGetFileDetailsResponseToJSON,
    FileServiceGetFileLinkResponseFromJSON,
    FileServiceGetFileLinkResponseToJSON,
} from '../models/index';

export interface FileApiApiFileCreateFilePostRequest {
    file?: Blob;
}

export interface FileApiApiFileGetFileGetRequest {
    fileId?: string;
    getData?: boolean;
}

export interface FileApiApiFileGetFileLinkGetRequest {
    fileId?: string;
    fileNameForLink?: string;
    timeToLiveForLink?: number;
}

/**
 * 
 */
export class FileApi extends runtime.BaseAPI {

    /**
     */
    async apiFileCreateFilePostRaw(requestParameters: FileApiApiFileCreateFilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }


        let urlPath = `/api/File/CreateFile`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiFileCreateFilePost(requestParameters: FileApiApiFileCreateFilePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiFileCreateFilePostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiFileGetFileGetRaw(requestParameters: FileApiApiFileGetFileGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileServiceGetFileDetailsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['fileId'] != null) {
            queryParameters['FileId'] = requestParameters['fileId'];
        }

        if (requestParameters['getData'] != null) {
            queryParameters['GetData'] = requestParameters['getData'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/File/GetFile`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileServiceGetFileDetailsResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFileGetFileGet(requestParameters: FileApiApiFileGetFileGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileServiceGetFileDetailsResponse> {
        const response = await this.apiFileGetFileGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFileGetFileLinkGetRaw(requestParameters: FileApiApiFileGetFileLinkGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileServiceGetFileLinkResponse>> {
        const queryParameters: any = {};

        if (requestParameters['fileId'] != null) {
            queryParameters['FileId'] = requestParameters['fileId'];
        }

        if (requestParameters['fileNameForLink'] != null) {
            queryParameters['FileNameForLink'] = requestParameters['fileNameForLink'];
        }

        if (requestParameters['timeToLiveForLink'] != null) {
            queryParameters['TimeToLiveForLink'] = requestParameters['timeToLiveForLink'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/File/GetFileLink`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileServiceGetFileLinkResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFileGetFileLinkGet(requestParameters: FileApiApiFileGetFileLinkGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileServiceGetFileLinkResponse> {
        const response = await this.apiFileGetFileLinkGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
